/** @module IglooModule **/

/**
 * This function returns information about the browser including name, version,
 * whether or not it is a mobile or bot browser
 * @param  {String} user_agent The user agent to parse
 * @return {Object}            The browser information
 */
function get_browser_information(user_agent) {
  // Set the default values
  var is_mobile = false;
  var is_bot = false;

  try {
    // Perform the first match
    var version_match;
    var browser_match = user_agent.match(/(opera|googlebot|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    // Determine mobile/bot
    is_mobile = /Android|BlackBerry|iPhone|iPod|Opera Mini|IEMobile/i.test(user_agent);
    is_bot = /bot|googlebot|crawler|spider|robot|crawling|phantomjs/i.test(user_agent);

    // Check for trident (IE)
    if (/trident/i.test(browser_match[1])) {
      version_match = /\brv[ :]+(\d+)/g.exec(user_agent) || [];
      return {
        name: 'IE',
        version: version_match[1] || '',
        bot: is_bot,
        mobile: is_mobile,
      };
    }

    // Check for Chrome to filter out Opera and Edge
    if (browser_match[1] === 'Chrome') {
      version_match = user_agent.match(/\b(OPR|EDGE)\/(\d+)/i);

      // Check for version_match
      if (version_match !== null) {
        return {
          name: version_match[1].replace('OPR', 'Opera'),
          version: version_match[2],
          bot: is_bot,
          mobile: is_mobile,
        };
      }
    }

    // Everyone else
    browser_match = browser_match[2] ? browser_match.slice(1, 3) : [navigator.appName, navigator.appVersion, '-?'];

    // Get the version
    version_match = user_agent.match(/version\/(\d+)/i);
    if (version_match !== null) {
      browser_match.splice(1, 1, version_match[1]);
    }

    return {
      name: browser_match[0].replace('MSIE', 'IE'),
      version: browser_match[1],
      bot: is_bot,
      mobile: is_mobile,
    };
  } catch (e) {
    return {
      error: e,
      name: 'Unknown',
      version: 'Unknown',
      bot: is_bot,
      mobile: is_mobile,
    };
  }
} // --> get_browser_information

/**
 * The igloo module
 * @type {Object}
 */
module.exports = {
  /**** GENERAL VARIABLES ****/

  /**
   * An array of the igloo ad zones on the page
   * @type {Array}
   */
  ad_zones: [],

  /**
   * This function creates a new igloo ad zone and adds it to the array
   * @param  {Array} presets The 4 preset values to pass into the Ad Zone
   */
  add_zone: function(presets) {
    this.ad_zones.push(require('./IglooAdZone')(this, this.ad_zones.length, presets));
  },

  /**
   * Make this function accesible outside the module for unit testing
   * @type {Function}
   */
  get_browser_information: get_browser_information,

  /**
   * This object describes the current browser including name, version, mobile,
   * and bot
   * @type {Object}
   * @key  {String}  name    The name of the broswer (Chrome, IE, etc)
   * @key  {String}  version The version of the browser
   * @key  {Boolean} bot     Whether the browser is a bot or not
   * @key  {Boolean} mobile  Whether the browser is mobile or not
   */
  browser: get_browser_information(navigator.userAgent),

  /**
   * The time the igloo module was loaded
   * @type {Number}
   */
  started: (new Date()).getTime(),

  /**** TRACKING VARIABLES ****/

  /**
   * An array of which pageview events have been called. A unique pageview will
   * be called for each partner
   * @type {Array}
   */
  tracker_called: [],

  /**
   * An array of the hashes of the creatives that have been sent so the same
   * creative isn't sent repeatedly
   * @type {Array}
   */
  creatives_sent: [],

  /**** RUBICON VARIABLES ****/

  /**
   * Whether Rubicon is able to be enabled:
   * -2: Default, no action has been taken
   * -1: Geolocation is being checked
   * 0: Rubicon is not allowed (geolocation failed)
   * 1: Rubicon is allowed (geolocation complete)
   * @type {Number}
   */
  allow_rubicon: -2, // Flag for rubicon inclusion

  /**
   * An array of functions to run to enable Rubicon
   * @type {Array}
   */
  rubicon_enable: [], // Functions to enable rubicon

  /**** REALVU VARIABLES ****/

  /**
   * Flag to determine if RealVu's library has been embedded
   * @type {Boolean}
   */
  realvu_embeded: false,

  /**** ADBLADE VARIABLES ****/

  /**
   * What partner ID is allowed to use AdBlade
   * @type {Integer}
   */
  adblade_partner: null,

  /**** FUNCTIONS FOR CONTROL ****/

  /**
   * Whether to enable debugging logs and divs
   * @type {Boolean}
   */
  debug: false,

  /**
   * Toggles debugging mode
   * @param  {String}         mode (Optional) The new debugging mode
   * @return {String|Boolean}      The new value for igloo.debug
   */
  toggleDebug: function(mode) {
    // Check for mode being undefined
    if (typeof mode === 'undefined') {
      this.debug = this.debug === false;
      return this.debug;
    }

    // Switch based on mode
    switch (mode) {
      case 'v':
        this.debug = 'v';
        break;
      case 'vv':
        this.debug = 'vv';
        break;
      default:
        this.debug = true;
        break;
    }
    return this.debug;
  },

  /**
   * Whether to pause all ad units
   * @type {Boolean}
   */
  pause: false,

  /**
   * Toggles the global pausing
   */
  pauseAd: function() {
    this.pause = !this.pause;
  },
};
